<template>
  <div class="simpleBroad">
    <div class="row" v-for="(item, index) in area" :key="index">
      <div
        class="col-md-3 outer-frame"
        v-for="(shife, index) in item"
        :key="index"
      >
        <h3>{{ shife.name }}排班站 ({{ shife.driverInfo.length }})</h3>
        <div
          class="iner-frame"
          v-for="(driver, index) in shife.driverInfo"
          @click="_clickDrvierInfo(driver, shife.name)"
          :key="index"
        >
          <span class="fontSize20">隊編/呼號:{{ driver.callNumber }}</span>
          <span class="fontSize20">時間:{{ driver.shiftUpdatedTime }}</span>
          <span class="fontSize20">備註:{{ driver.driverNote }}</span>
          <span class="fontSize20">({{ scheduledState(driver, index) }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constants } from 'fs'
export default {
  props: ['shiftDriver'],
  data() {
    return {
      scheduling: true,
    }
  },
  methods: {
    _clickDrvierInfo(value, shiftName) {
      let info = {
        shiftName,
        callNumber: value.callNumber,
        account: value.account,
        shiftUpdatedTime: value.shiftUpdatedTime,
      }
      this.$emit('driver-scheduled-info', info)
    },
    scheduledState(value, index) {
      // console.log(value)
      switch (value.state) {
        case 4:
          return index + 1
          break
        case 2:
          this.scheduling = false
          return '派遣中'
          break
        default:
          return '異常'
          break
      }
    },
  },
  computed: {
    area() {
      console.log(this.shiftDriver)
      let array = []
      let total = []
      let count = 0
      this.shiftDriver.sort(function (a, b) {
        return a.name > b.name ? 1 : -1
      })
      for (let i = 0; i < this.shiftDriver.length; i++) {
        count++
        array.push(this.shiftDriver[i])
        if (count === 4 || this.shiftDriver.length - i - 1 === 0) {
          total.push(array)
          array = []
          count = 0
          continue
        }
      }

      return total
    },
  },
}
</script>

<style scoped>
.outer-frame {
  border: solid 1px black;
}
.iner-frame {
  border: solid 1px black;
  margin-top: 5px;
}
span {
  color: black;
}
.iner-frame:hover {
  background-color: #ffcccc;
}
</style>



// WEBPACK FOOTER //
// src/components/areaComponent/simpleBroad_v1.vue